import React from 'react'
import Liberyus from '../../components/general/liberyus'
import PartnershipBanner from './partnership-banner'
import { Col, Row } from 'reactstrap'
import prt1 from '../../assets/images/prt1.svg'
import prt2 from '../../assets/images/prt2.svg'
import prt3 from '../../assets/images/prt3.svg'
import prt4 from '../../assets/images/prt4.svg'
import prt5 from '../../assets/images/prt5.svg'
import prt6 from '../../assets/images/prt6.svg'
import prt7 from '../../assets/images/prt7.svg'
import prt8 from '../../assets/images/prt8.svg'
import prt9 from '../../assets/images/prt9.svg'
import prt10 from '../../assets/images/prt10.svg'
import prt11 from '../../assets/images/prt11.svg'

const PartnershipPage = () => {
    return (
        <Liberyus>
            <div className='partnership-page'>
                <PartnershipBanner />
                <Row className='partners'>
                    <Col xs={0} sm={0} md={0} lg={1} xl={1} xxl={1}></Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt1} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt2} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt3} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt4} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt5} alt='' /></div>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={1} xl={1} xxl={1}></Col>
                    <Col xs={0} sm={0} md={0} lg={1} xl={1} xxl={1}></Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt6} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt7} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt8} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt9} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt10} alt='' /></div>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={1} xl={1} xxl={1}></Col>
                    <Col xs={0} sm={0} md={0} lg={1} xl={1} xxl={1}></Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt11} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt1} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt2} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt3} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt4} alt='' /></div>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={1} xl={1} xxl={1}></Col>
                    <Col xs={0} sm={0} md={0} lg={1} xl={1} xxl={1}></Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt5} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt6} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt7} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt8} alt='' /></div>
                    </Col>
                    <Col xs={6} sm={6} md={4} lg={2} xl={2} xxl={2} className='mb-4 d-flex justify-content-center'>
                        <div className='item'><img src={prt9} alt='' /></div>
                    </Col>
                    <Col xs={0} sm={0} md={0} lg={1} xl={1} xxl={1}></Col>
                </Row>
            </div>
        </Liberyus>
    )
}

export default PartnershipPage
